<template>
  <div class="box">
    <div class="display-name">
      {{ from }} <svg width="5" height="7" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.5 3.487L.303 5.435a.866.866 0 0 0 0 1.296c.417.37 1.045.37 1.462 0l2.851-2.527a.866.866 0 0 0 .08-1.362L1.795.269a1.102 1.102 0 0 0-1.462 0 .866.866 0 0 0 0 1.296L2.5 3.487z" fill="#5EB4EB" fill-rule="evenodd"/>
      </svg> {{ to }}
    </div>
    <div class="timers">
      <div class="timer main" id="countdown-0" ref="countdown-0">0:00:00</div>
      <div class="next">daarna</div>
      <div class="timer" id="countdown-1" ref="countdown-1">0:00:00</div>
    </div><!-- /.timers -->

    <div class="return-display-name" @click="switchDirection()">
      {{ to }} <svg width="5" height="7" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.5 3.487L.303 5.435a.866.866 0 0 0 0 1.296c.417.37 1.045.37 1.462 0l2.851-2.527a.866.866 0 0 0 .08-1.362L1.795.269a1.102 1.102 0 0 0-1.462 0 .866.866 0 0 0 0 1.296L2.5 3.487z" fill="#5EB4EB" fill-rule="evenodd"/>
      </svg> {{ from }}
    </div>
    <div class="return" @click="switchDirection()">
      <svg width="23" height="24" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.266 3.233c3.72 0 6.734 3.108 6.734 6.942v1.366c-1.229-1.684-3.183-2.774-5.385-2.774H7.808V12L0 6l7.808-6v3.233h8.458zm-1.11 12.007v-3.23l7.791 5.995L15.157 24v-3.23H6.718C3.008 20.77 0 17.664 0 13.833V12.47c1.226 1.683 3.176 2.771 5.372 2.771h9.785z" fill="#FFF" fill-rule="evenodd"/>
      </svg>
    </div>
    <div v-if="favorites && user" class="favorite" :class="{'active': isFavorite}" @click="toggleIsFavorite()">
      <svg width="17" height="16" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.501 14.081l6.36-6.362A3.945 3.945 0 1 0 8.5 3.232a3.946 3.946 0 1 0-6.333 4.515L8.5 14.081z" stroke="#F5A623" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linejoin="round"/>
      </svg>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import countdown from 'countdown'
import { mapState } from 'vuex'

export default {
  props: {
    propFrom: {
      type: String,
      required: true,
      default: ''
    },
    propTo: {
      type: String,
      required: true,
      default: ''
    }
  },
  data() {
    return {
      from: false,
      to: false,
      departures: false,
      localTime: false,
      serverTime: false,
      countdownsInitialized: false,
      timers: [],
      isActive: false,
      favorites: true,
      lineId: 0,
      lineUid: ''
    }
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
    isFavorite () {
      if (this.user && this.user.favorites && this.user.favorites.length) {
        return this.user.favorites.findIndex((favorite) => {
          return favorite.uid === this.lineUid
        }) > -1
      }
      return false
    }
  },
  methods: {
    getLineId (lineUid) {
      axios.get(`${process.env.VUE_APP_API_URL}/lines/${lineUid}`)
        .then(response => {
          this.lineId = response.data
        })
    },
    toggleIsFavorite () {
      this.$store.dispatch('toggleFavorite', {
        lineID: this.lineId,
        isFavorite: this.isFavorite
      })
    },
    getDepartures () {
      axios.get(`${process.env.VUE_APP_API_URL}/departures/?line=${this.from} - ${this.to}`)
        .then(response => {
          this.departures = response.data
          this.initCountdown()
          this.lineUid = response.data[0].line_uid
          this.getLineId(this.lineUid)
        })
    },
    getServerTime () {
      axios.get(`${process.env.VUE_APP_API_URL}/servertime`)
        .then(response => {
          this.localTime = new Date()
          this.serverTime = new Date(response.data)
          this.initCountdown()
        })
        .catch(() => {
          this.localTime = new Date()
          this.serverTime = new Date()
          this.initCountdown()
        })
    },
    goToStops () {
      this.$router.push(`/stops`)
    },
    initCountdown () {
      if (!this.serverTime || !this.departures[0] || !this.departures[1] || this.countdownsInitialized) {
        return
      }
      this.countdownsInitialized = true

      for (let i = 0; i < this.departures.length; i++) {
        // Get time difference between local and server time
        const timeDiff = Math.round((this.localTime - this.serverTime) / 1000)

        // Make Date object based on expected_departure_time
        const departureTime = this.departures[i].expected_departure_time.split(':')
        const departureDate = new Date()
        departureDate.setHours(departureTime[0])
        departureDate.setMinutes(departureTime[1])
        departureDate.setSeconds(departureTime[2])

        // Adjust departure time based on time difference
        departureDate.setSeconds(departureDate.getSeconds() + timeDiff)

        // Initialize countdown
        const _this = this

        this.timers[i] = countdown(
          departureDate,
          function (ts) {
            const hours = ts.hours
            const minutes = (ts.minutes < 10) ? `0${ts.minutes}` : ts.minutes
            const seconds = (ts.seconds < 10) ? `0${ts.seconds}` : ts.seconds

            _this.$refs['countdown-' + i].innerHTML = `${hours}:${minutes}:${seconds}`

            if (departureDate.getTime() < (new Date()).getTime()) {
              _this.clearTimers()
              _this.getDepartures()
            }
          },
          countdown.HOURS|countdown.MINUTES|countdown.SECONDS
        )
      }
    },
    clearTimers () {
      for (let i = 0; i < this.timers.length; i++) {
        window.clearInterval(this.timers[i])
      }

      this.countdownsInitialized = false
      this.departures = []
      this.localTime
      this.serverTime
      this.timers = []
    },
    switchDirection () {
      this.clearTimers()

      const from = this.from
      this.from = this.to
      this.to = from

      const url = `/stops/${this.from}/${this.to}`
      this.$router.push(url)
      this.$forceUpdate()
    }
  },
  watch: {
    from () {
      this.$store.commit('SET_BACK_BUTTON', `/stops/${this.from}`)
      this.getDepartures()
      this.getServerTime()
    }
  },
  beforeDestroy () {
    this.clearTimers()
  },
  created() {
    this.to = this.propTo
    this.from = this.propFrom
  }
}
</script>
